import { useToken } from '@ori/auth';
import { useServiceUrls } from '@ori/configuration-manager';
import { useEnvironment } from '@ori/environment';
import { ApiClientProvider } from '@ori/global-api-client-react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApiProvider = ({
  children
}) => {
  const {
    tenant
  } = useEnvironment();
  const {
    globalApiUrl
  } = useServiceUrls(['globalApi']);
  const {
    token
  } = useToken();
  return /*#__PURE__*/_jsx(ApiClientProvider, {
    baseUrl: globalApiUrl,
    tenant: tenant,
    token: token,
    children: children
  });
};
//# sourceMappingURL=ApiProvider.js.map